export default [
// const dataSource = [
    {
        key: '1',
        cust_code: '1001001',
        cust_name: 'Shawarma Co.',
        cust_status: 'ACTIVE',
    },
    {
        key: '2',
        cust_code: '1001002',
        cust_name: 'Kanto Kantina Corp.',
        cust_status: 'INACTIVE',
    },
  ];